import { queryOptions } from "@tanstack/react-query";
import {
  adminGetQuoteFn,
  adminListQuotesFn,
  corporateDashboardFn,
  getCorporatePackFn,
  listCorporatePacksFn,
  myQuotesFn,
} from "./corporate.functions";
import type { CorporateQuoteStatus } from "./types";

export const corporatePacksQuery = () =>
  queryOptions({
    queryKey: ["corporate", "packs"],
    queryFn: () => listCorporatePacksFn(),
    staleTime: 60_000,
  });

export const corporatePackQuery = (slug: string) =>
  queryOptions({
    queryKey: ["corporate", "pack", slug],
    queryFn: () => getCorporatePackFn({ data: { slug } }),
    staleTime: 60_000,
  });

export const myQuotesQuery = () =>
  queryOptions({
    queryKey: ["corporate", "my-quotes"],
    queryFn: () => myQuotesFn(),
    staleTime: 15_000,
  });

export type AdminQuoteFilters = { search?: string; status?: CorporateQuoteStatus | "all"; salesRepEmail?: string };

export const adminQuotesQuery = (filters: AdminQuoteFilters = {}) =>
  queryOptions({
    queryKey: ["admin", "corporate", "quotes", filters],
    queryFn: () => adminListQuotesFn({ data: filters }),
    staleTime: 10_000,
  });

export const adminQuoteQuery = (id: string) =>
  queryOptions({
    queryKey: ["admin", "corporate", "quote", id],
    queryFn: () => adminGetQuoteFn({ data: { id } }),
    staleTime: 5_000,
  });

export const adminCorporateDashboardQuery = () =>
  queryOptions({
    queryKey: ["admin", "corporate", "dashboard"],
    queryFn: () => corporateDashboardFn(),
    staleTime: 30_000,
  });